// 두 가지 일자 중 나중 일자
export function getBiggerDate( date1:any, date2:any ){
  const DATE1:any = new Date( date1 );
  const DATE2:any = new Date( date2 );
  const bigger = Math.max(  Math.floor( DATE1 / 1000) , Math.floor( DATE2 / 1000) );
  
  return new Date( bigger * 1000 );
}

// 두 가지 일자 중 이전 일자
export function getSmallerDate( date1:any, date2:any ){
  const DATE1:any = new Date( date1 );
  const DATE2:any = new Date( date2 );
  const bigger = Math.min(  Math.floor( DATE1 / 1000) , Math.floor( DATE2 / 1000) );
  
  return new Date( bigger * 1000 );
}

// 이메일 체크 정규식
export function isEmail(asValue:any) {
	const regExpOneDot = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]+$/i;
	const regExpTowDot = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]+\.[a-zA-Z]+$/i;
  
	return ( regExpOneDot.test(asValue) || regExpTowDot.test(asValue) ); // 형식에 맞는 경우 true 리턴
}

// 일자로 요일 검색 후 요일 텍스트 리턴 (param format: yyyy-MM-dd)
export function getDayOfWeek(yyyyMMdd:any){
  const dayOfWeek = new Date(yyyyMMdd).getDay();
  switch ( dayOfWeek ) {
    case 0 : return '일';
    case 1 : return '월';
    case 2 : return '화';
    case 3 : return '수';
    case 4 : return '목';
    case 5 : return '금';
    case 6 : return '토';
    default: return '일';
  }
}

// date to string 원하는 포맷 및 일자(오늘 기준 0, 이전 마이너스, 이후 플러스 값)
export function getDateByCustom(format :any, dayValue :any) {
  let returnStr = '';
  const today = new Date();
  const targetDay = new Date(today.setDate(today.getDate() + (dayValue)));
  const year = targetDay.getFullYear();
  const month = (targetDay.getMonth() + 1) >= 10 ? (targetDay.getMonth() + 1) : '0' + (targetDay.getMonth() + 1);
  const date = targetDay.getDate() >= 10 ? targetDay.getDate() : '0' + targetDay.getDate();
  
  if(format === 'yyyyMMdd'){
    returnStr = year + '' + month + '' + date;
  }else if (format === 'yyyy-MM-dd'){
    returnStr = year + '-' + month + '-' + date;
  }
  
	return returnStr;
}

// null check
export function strNull(val :any){
  if (new String(val).valueOf() == 'undefined')
    return '';
  if (val == null)
    return '';
  if (('x' + val == 'xNaN') && (new String(val.length).valueOf() == 'undefined'))
    return '';
  if (val.toString().length == 0)
    return '';
  
  return val.toString();
}

// time(단위 시간), mets 값, 몸무게를 통해 소비칼로리 계산 // return 소수점 5자리 반올림 후 number로 0 제거
export function getCaloryByMets(time :any, mets :any, weight :any){
  return Number((time*mets*weight*1.05).toFixed(5));
}

// time(단위 시간), 소비칼로리, 몸무게를 통해 mets 값 계산
export function getMetsByCalory(time :any, calory :any, weight :any){
  return calory/(time*weight*1.05);
}

// 숫자 3자리마다 콤마 찍기!
export function formatComma(num :any){
  return Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// 핸드폰번호 010-0000-0000 포맷 실시간 하이픈(-) 추가
export function formatPhoneNumber(value: any) {
  if (!value) {
    return "";
  }

  value = value.replace(/[^0-9]/g, "");

  let result = [];
  let restNumber = "";

  // 지역번호와 나머지 번호로 나누기
  if (value.startsWith("02")) {
    // 서울 02 지역번호
    result.push(value.substr(0, 2));
    restNumber = value.substring(2);
  } else if (value.startsWith("1")) {
    // 지역 번호가 없는 경우
    // 1xxx-yyyy
    restNumber = value;
  } else {
    // 나머지 3자리 지역번호
    // 0xx-yyyy-zzzz
    result.push(value.substr(0, 3));
    restNumber = value.substring(3);
  }

  if (restNumber.length === 7) {
    // 7자리만 남았을 때는 xxx-yyyy
    result.push(restNumber.substring(0, 3));
    result.push(restNumber.substring(3));
  } else {
    result.push(restNumber.substring(0, 4));
    result.push(restNumber.substring(4));
  }

  return result.filter((val) => val).join("-");
}